import React from 'react';
import { Card, List, Row, Typography } from 'antd';
import { MessageOutlined, PlusOutlined } from '@ant-design/icons';
import Button from "@common/Button";
import EditableSectionDevelopment from "./EditableSectionDevelopment";

const { Title, Text, Paragraph } = Typography;

const LanguageScaffoldsCard = ({
    academicLanguageScaffolds,
    isEditMode,
    editingState,
    adaptedKeys,
    handleEdit,
    handleContentChange,
    handleSave,
    handleCancel,
    handleAddListItem,
    handleRemoveListItem,
    handleClearField
}) => {
    return (
        <div id="lesson-language">
            <Title level={2}>Academic Language Scaffolds</Title>
            <Card size="small" icon={<MessageOutlined />}>
                {academicLanguageScaffolds && (
                    <EditableSectionDevelopment
                        contentKey='academicLanguageScaffolds.discourseType'
                        editContent={editingState.key === 'academicLanguageScaffolds.discourseType' ? editingState.content : academicLanguageScaffolds.discourseType}
                        isEditing={editingState.key === 'academicLanguageScaffolds.discourseType'}
                        isAdapted={adaptedKeys.has('academicLanguageScaffolds.discourseType')}
                        onEdit={isEditMode ? handleEdit : undefined}
                        onChange={isEditMode ? handleContentChange : undefined}
                        onSave={isEditMode ? handleSave : undefined}
                        onCancel={isEditMode ? handleCancel : undefined}
                        onDelete={isEditMode ? () => handleClearField('academicLanguageScaffolds.discourseType', 'Discourse Type') : undefined}
                        deleteTooltip="Clear discourse type"
                    >
                        <Paragraph><strong>Discourse Type:</strong> {academicLanguageScaffolds.discourseType || <Text type="secondary" italic>Not specified</Text>}</Paragraph>
                    </EditableSectionDevelopment>
                )}
                <Row justify="space-between" align="middle" style={{marginTop: 8, marginBottom: 8}}>
                    <Title level={5} style={{marginTop: 0, marginBottom: 0}}>Sentence Stems</Title>
                    {isEditMode && (
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            size="small"
                            onClick={() => handleAddListItem('academicLanguageScaffolds.stems', 'New stem. Click to edit.', 'Sentence Stem')}
                        >
                            Add Stem
                        </Button>
                    )}
                </Row>
                <List
                    dataSource={academicLanguageScaffolds?.stems || []}
                    renderItem={(item, itemIndex) => (
                        <List.Item key={itemIndex}>
                            {(() => {
                                const contentKey = `academicLanguageScaffolds.stems.${itemIndex}`;
                                const isEditingThisOne = editingState.key === contentKey;
                                return (
                                    <EditableSectionDevelopment
                                        contentKey={contentKey}
                                        editContent={isEditingThisOne ? editingState.content : item}
                                        isEditing={isEditingThisOne}
                                        isAdapted={adaptedKeys.has(contentKey)}
                                        onEdit={isEditMode ? handleEdit : undefined}
                                        onChange={isEditMode ? handleContentChange : undefined}
                                        onSave={isEditMode ? handleSave : undefined}
                                        onCancel={isEditMode ? handleCancel : undefined}
                                        onDelete={isEditMode ? () => handleRemoveListItem('academicLanguageScaffolds.stems', itemIndex, item) : undefined}
                                        deleteTooltip="Remove stem"
                                    >
                                        <Text code>{item}</Text>
                                    </EditableSectionDevelopment>
                                );
                            })()}
                        </List.Item>
                    )}
                />
            </Card>
        </div>
    );
};

export default LanguageScaffoldsCard;
